import API from 'services/API';

export default function getOkveds(params) {
  return API.request({
    method: 'GET',
    url: `/dicts/okved`,
    params,
  });
}
